import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class CountryTuitionFeeRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return (
			indexableFilters.length === 2 &&
			indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			indexableFilters.some((_) => _.type === ParameterType.TUITION_FEE)
		);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.COUNTRY_TUITION_FEE_ROUTE,
			params: {
				country: this.extractPath(filters.find((_) => _.type === ParameterType.COUNTRY)),
				tuition_fee: this.extractPath(filters.find((_) => _.type === ParameterType.TUITION_FEE))
			}
		};
	}
}
